import { render, staticRenderFns } from "./StatusAutomationEditDialog.vue?vue&type=template&id=6844a98d&scoped=true"
import script from "./StatusAutomationEditDialog.vue?vue&type=script&lang=js"
export * from "./StatusAutomationEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6844a98d",
  null
  
)

export default component.exports